// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.504Z

const videoTourCabinet = {
  pageName: `Cabinet`,
  tourTitle: `Keep all your Documents Organized with Cabinet`,
  videoUrl: `https://www.loom.com/embed/7533d7889fca44f7ae4f6c96b1278ac0`,
  description: `The cabinet will automatically be updated with all of the documents that your staff sign so that you can remain legally protected. You can also upload documents in here yourself so that you have all the information in one place.`,
  buttonLabel: `Sounds Good!`,
} as const;

export default videoTourCabinet;
